export const emptyDisplayValue = '—';
